/**
 * Creates a key-scoped storage interface
 * @param {Storage} storage an object meeting the web storage interface
 * https://developer.mozilla.org/en-US/docs/Web/API/Storage
 */
export function createStorage(key, storage = window.localStorage) {
  const get = () => {
    try {
      return JSON.parse(storage.getItem(key));
    } catch (error) {
      console.error(`error getting storage: key - ${key}`);
      return null;
    }
  };

  const set = (newValue) => {
    try {
      storage.setItem(key, JSON.stringify(newValue));
    } catch (error) {
      console.error(`error setting storage: key - ${key}, value - ${newValue}`);
    }
  };

  const remove = () => {
    try {
      storage.removeItem(key);
    } catch (error) {
      console.error(`error removing storage: key - ${key}`);
    }
  };

  return {
    get,
    set,
    remove,
  };
}
